import React from 'react';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import I18n from '../hoc/I18n';
import reducer from '../reducers/index';
import router from '../routes';
import translations from '../i18n/translations';
import 'react-toastify/dist/ReactToastify.css';

const Root = () => {
    const store = getReduxStore();
    const I18nRouterProvider = I18n(RouterProvider, translations);

    return (
        <Provider store={store}>
            <I18nRouterProvider router={router}/>
            <ToastContainer position="bottom-right"/>
        </Provider>
    );
};

const getReduxStore = () => {
    if (process.env.NODE_ENV === 'production') {
        return createStore(reducer, applyMiddleware(thunk));
    }

    return createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
};

export default Root;
